/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featured_HeadingInputs */

const zh_featured_heading = /** @type {(inputs: Featured_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索更多精选案例`)
};

const en_featured_heading = /** @type {(inputs: Featured_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore Featured Examples`)
};

const es_featured_heading = /** @type {(inputs: Featured_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar ejemplos destacados`)
};

/**
* | output |
* | --- |
* | "Explore Featured Examples" |
*
* @param {Featured_HeadingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const featured_heading = /** @type {((inputs?: Featured_HeadingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_HeadingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_featured_heading(inputs)
	if (locale === "en") return en_featured_heading(inputs)
	return es_featured_heading(inputs)
});